/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutboundPlanBigTableVo } from './OutboundPlanBigTableVo';
import {
    OutboundPlanBigTableVoFromJSON,
    OutboundPlanBigTableVoFromJSONTyped,
    OutboundPlanBigTableVoToJSON,
    OutboundPlanBigTableVoToJSONTyped,
} from './OutboundPlanBigTableVo';

/**
 * 
 * @export
 * @interface ResponseListOutboundPlanBigTableVo
 */
export interface ResponseListOutboundPlanBigTableVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListOutboundPlanBigTableVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListOutboundPlanBigTableVo
     */
    message?: string;
    /**
     * 
     * @type {Array<OutboundPlanBigTableVo>}
     * @memberof ResponseListOutboundPlanBigTableVo
     */
    data?: Array<OutboundPlanBigTableVo>;
}

/**
 * Check if a given object implements the ResponseListOutboundPlanBigTableVo interface.
 */
export function instanceOfResponseListOutboundPlanBigTableVo(value: object): value is ResponseListOutboundPlanBigTableVo {
    return true;
}

export function ResponseListOutboundPlanBigTableVoFromJSON(json: any): ResponseListOutboundPlanBigTableVo {
    return ResponseListOutboundPlanBigTableVoFromJSONTyped(json, false);
}

export function ResponseListOutboundPlanBigTableVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListOutboundPlanBigTableVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(OutboundPlanBigTableVoFromJSON)),
    };
}

export function ResponseListOutboundPlanBigTableVoToJSON(json: any): ResponseListOutboundPlanBigTableVo {
    return ResponseListOutboundPlanBigTableVoToJSONTyped(json, false);
}

export function ResponseListOutboundPlanBigTableVoToJSONTyped(value?: ResponseListOutboundPlanBigTableVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(OutboundPlanBigTableVoToJSON)),
    };
}

